import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import {
  GraphElementType,
  GraphMode,
  TimEdgeCytoElement,
  TimLinkProps,
} from "@/types";
import { getTraceId, sanitizeNodeId } from "@/util";
import { selectionStore, useTheme, viewsStore } from "@/hooks";
import { CyElement } from "@/components/graph/base";


/**
 * Displays trace link edges between artifact types.
 */
const __default__ = {
  name: "TimLink",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    sourceType: {},
    targetType: {},
    count: {},
    generated: { type: Boolean },
    hideActions: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { darkMode } = useTheme();

const definition = computed<TimEdgeCytoElement>(() => ({
  data: {
    type: GraphElementType.edge,
    graph: "tim" as GraphMode,
    id: sanitizeNodeId(getTraceId(props.sourceType, props.targetType)),

    // Reversed to show arrow toward parent.
    sourceType: props.targetType,
    targetType: props.sourceType,
    source: sanitizeNodeId(props.targetType),
    target: sanitizeNodeId(props.sourceType),

    count: props.count,
    label:
      props.count < 0
        ? "1 Import"
        : props.count === 1
          ? `1 Link`
          : `${props.count} Links`,
    dark: darkMode.value,
    generated: props.generated,
  },
  classes: props.sourceType === props.targetType ? "loop" : "",
}));

/**
 * Selects this trace matrix.
 */
function handleSelect(): void {
  if (props.hideActions) return;

  if (
    selectionStore.selectedTraceMatrixTypes[0] !== props.targetType ||
    selectionStore.selectedTraceMatrixTypes[1] !== props.sourceType
  ) {
    selectionStore.selectTraceMatrix(props.sourceType, props.targetType);
  } else {
    viewsStore.addDocumentOfTypes([props.sourceType, props.targetType]);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CyElement), {
    definition: definition.value,
    onClick: handleSelect
  }, null, 8, ["definition"]))
}
}

})